export const EXCMDEVICESTATE_SHOW_RESET = 'EXCMDEVICESTATE_SHOW_RESET'
export const EXCMDEVICESTATE_SHOW_SET_ERROR = 'EXCMDEVICESTATE_SHOW_SET_ERROR'
export const EXCMDEVICESTATE_SHOW_SET_RETRIEVED = 'EXCMDEVICESTATE_SHOW_SET_RETRIEVED'
export const EXCMDEVICESTATE_SHOW_TOGGLE_LOADING = 'EXCMDEVICESTATE_SHOW_TOGGLE_LOADING'
